/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A4uCalendar = A4uCalendar;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function A4uCalendar(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 36 36"
  }, props, props), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M33,6H28V3a1,1,0,0,0-1-1H25a1,1,0,0,0-1,1V6H10V3A1,1,0,0,0,9,2H7A1,1,0,0,0,6,3V6H1A1,1,0,0,0,0,7V33a1,1,0,0,0,1,1H33a1,1,0,0,0,1-1V7A1,1,0,0,0,33,6ZM32,32H2V8H6V9a1,1,0,0,0,1,1H9a1,1,0,0,0,1-1V8H24V9a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V8h4Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fillRule: "evenodd",
    x: "6",
    y: "12",
    width: "4",
    height: "4"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fillRule: "evenodd",
    x: "12",
    y: "12",
    width: "4",
    height: "4"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fillRule: "evenodd",
    x: "18",
    y: "12",
    width: "4",
    height: "4"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fillRule: "evenodd",
    x: "24",
    y: "12",
    width: "4",
    height: "4"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fillRule: "evenodd",
    x: "6",
    y: "18",
    width: "4",
    height: "4"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fillRule: "evenodd",
    x: "12",
    y: "18",
    width: "4",
    height: "4"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fillRule: "evenodd",
    x: "18",
    y: "18",
    width: "4",
    height: "4"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fillRule: "evenodd",
    x: "24",
    y: "18",
    width: "4",
    height: "4"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fillRule: "evenodd",
    x: "6",
    y: "24",
    width: "4",
    height: "4"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fillRule: "evenodd",
    x: "12",
    y: "24",
    width: "4",
    height: "4"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fillRule: "evenodd",
    x: "18",
    y: "24",
    width: "4",
    height: "4"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fillRule: "evenodd",
    x: "24",
    y: "24",
    width: "4",
    height: "4"
  }));
}